export default __webpack_public_path__ + "static/media/gaeko_desktop.1f3975ac.png";